import isString from 'lodash/isString';
import PropTypes from 'prop-types';
// @mui
import { Box, IconButton, Link, Stack, Typography } from '@mui/material';
//
import { useRouter } from 'next/router';
import Breadcrumbs from './Breadcrumbs';
import Iconify from './Iconify';

// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array.isRequired,
  subtitle: PropTypes.node,
  heading: PropTypes.string,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object,
};

export default function HeaderBreadcrumbs({ links, subtitle, heading, moreLink = '' || [], sx, ...other }) {
  let router = useRouter();

  return (
    <Box sx={{ ...sx }}>
      <Stack spacing={1}>
        <Breadcrumbs links={links} {...other} />
        {heading &&
          <Stack direction={"row"} alignItems={"center"}>
            <IconButton size='small' onClick={() => router.back()} sx={{ mr: 2 }}>
              <Iconify icon={'fa-solid:arrow-left'} sx={{ width: 15, height: 15 }} />
            </IconButton>
            <Typography variant='subtitle1' component={"h1"} textTransform={"inherit"}>
              {heading}
            </Typography>
          </Stack>}
        {subtitle && <Box sx={{ flexShrink: 0, pl: 8 }}>
          <Typography variant="body1">
            {subtitle}
          </Typography>
        </Box>}
      </Stack>

      <Box sx={{ mt: 2 }}>
        {isString(moreLink) ? (
          <Link href={moreLink} target="_blank" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link noWrap key={href} href={href} variant="body2" target="_blank" sx={{ display: 'table' }}>
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
